import Breadcrumb from '../../layout/breadcrumb';
import React, { useState, useEffect, Fragment, useCallback } from 'react';
import Rating from 'react-rating';
import { Container, Row, Col, Card, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';

import SweetAlert from 'sweetalert2';
import useQueue, { revealNFT } from '../../hooks/useQueue';
import { spaceship_firstName, spaceship_lastName } from '../../constant/names';

import { useGlobalState } from 'state-pool';

import CONTRACT_LIST from '../../contracts/contractList';
import spaceship_placeholder from '../../assets/images/spaceship_placeholder.png';
import { ASSETS_CDN } from '../../constant/config';
import { EternalBtn } from '../Button';
import { giftAsset } from '../gift-asset';
import { Information } from '../utils/Information';

import Moment from 'react-moment';

const Spaceships = (props) => {
  const [web3, setWeb3] = useGlobalState('Web3');
  const [videoAnimation] = useGlobalState('animateVideo');

  const [userAddress, setUserAddress] = useGlobalState('userAddress');

  const [stoneContract, setStoneContract] = useGlobalState('stoneContract');
  const [stoneAmount, setStoneAmount] = useGlobalState('stoneAmount');

  const [spaceshipContract, setSpaceshipContract] = useGlobalState('spaceshipContract');
  const [spaceshipAmount, setSpaceshipAmount] = useGlobalState('spaceshipAmount');

  const [cryptominesContract, setCryptominesContract] = useGlobalState('cryptominesContract');
  const [mintCost] = useGlobalState('mintCost');
  const [maxWorkers, setMaxWorkers] = useGlobalState('maxWorkers');

  const [spaceshipList, setSpaceships] = useState(0);
  const [canMint, setCanMint] = useState(1);

  const [marketplaceContract, setMarketplaceContract] = useGlobalState('marketplaceContract');

  const [loaded, setLoaded] = useState(0);
  const [toggleInformation, setToggleInformation] = useState(false);

  const [queueItems, setContracts, shouldUpdate] = useQueue();

  const MARKETPLACE_CONTRACT = CONTRACT_LIST['MARKETPLACE_CONTRACT'];

  useEffect(() => {
    async function initializeSpaceships() {
      setContracts({
        contract: spaceshipContract,
        userAddress,
      });
      reloadList();
    }

    if (cryptominesContract != null && loaded == 0) {
      initializeSpaceships();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spaceshipContract, userAddress]);

  const [layoutColumns, setLayoutColumns] = useState(3);
  const [open, setOpen] = useState(false);

  const reloadList = useCallback(async () => {
    const spaceshipArray = await cryptominesContract.methods.getMySpaceships().call({ from: userAddress });
    // const queueArray = await spaceshipContract.methods.getMyQueue(userAddress).call({ from: userAddress });
    // console.log(queueArray);
    //console.log(spaceshipArray)
    const spaceships = [];
    for (const tokenId of spaceshipArray) {
      const spaceshipData = await spaceshipContract.methods.getTokenDetails(tokenId).call({ from: userAddress });
      const transferCooldown = await spaceshipContract.methods.getTokenCooldown(tokenId).call({ from: userAddress });
      const spaceship = Object.assign({ id: tokenId }, spaceshipData);
      if (spaceship['firstName'] >= 0 && spaceship['firstName'] <= 60) {
        spaceship['variant'] = 1;
      } else if (spaceship['firstName'] >= 61 && spaceship['firstName'] <= 90) {
        spaceship['variant'] = 2;
      } else {
        spaceship['variant'] = 3;
      }
      spaceship['uid'] = spaceship['id'] + spaceship['roll'] + spaceship['firstName'] + spaceship['lastName'];

      const TRANSFER_TIME = 0;
      let now = parseInt((Date.now() / 1000).toFixed(0));
      if (transferCooldown > now - TRANSFER_TIME) {
        spaceship['canTransfer'] = 0;
      } else {
        spaceship['canTransfer'] = 1;
      }
      spaceship['transferCooldown'] = (parseInt(transferCooldown) + 0) * 1000;

      spaceships.push(spaceship);
    }

    if (spaceships.length > 10) {
      setCanMint(0);
    } else {
      setCanMint(1);
    }

    setSpaceships(spaceships);
    setLoaded(1);
  });

  const reloadData = async () => {
    const currentStones = await stoneContract.methods.balanceOf(userAddress).call({ from: userAddress });
    const currentSpaceships = await spaceshipContract.methods.balanceOf(userAddress).call({ from: userAddress });
    const currentMaxWorkers = await cryptominesContract.methods.getMaxWorkers().call({ from: userAddress }); //workers
    reloadList();
    setSpaceshipAmount(currentSpaceships);
    setStoneAmount(web3.utils.fromWei(currentStones, 'ether'));
    setMaxWorkers(currentMaxWorkers);
  };

  const mintSpaceship = async () => {
    // SweetAlert.fire({
    //   title: 'In maintenance',
    //   text: 'Know more at your Telegram or Discord.',
    //   icon: 'error',
    // });

    if (parseFloat(stoneAmount) < parseFloat(mintCost)) {
      SweetAlert.fire({
        title: 'Not enough $ETERNAL',
        text: 'Get more $ETERNAL to mint a new NFT.',
        icon: 'error',
      });
    } else {
      try {
        await cryptominesContract.methods.queueMint(1).send({ from: userAddress, value: 400000000000000 });
        window.gtag('event', 'mintSpaceship', { address: userAddress });

        cryptominesContract
          .getPastEvents('eventMintSpaceship', { fromBlock: 'latest', toBlock: 'latest', address: [userAddress] })
          .then(async (results) => {
            SweetAlert.fire({
              title: 'Great!',
              text: 'Your box has arrived. 📦',
              icon: 'success',
            });
          });

        reloadData();
        shouldUpdate(Math.random());
      } catch (error) {
        //console.log('error: ', error);
      }
    }
  };

  const burnSpaceship = async (tokenId, position) => {
    window.gtag('event', 'burnSpaceship', { tokenId: tokenId, address: userAddress });
    SweetAlert.fire({
      title: 'Be aware',
      html:
        'Once deleted, you will not be able to recover this NFT. It will be burned forever. 🔥 <br><br> <b>You will receive ' +
        (mintCost * 0.2).toFixed(3) +
        ' ETERNAL per burn. 🤑</b>',
      icon: 'warning',
      confirmButtonText: 'Proceed',
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        await cryptominesContract.methods.burnSpaceship(tokenId).send({ from: userAddress });
        setSpaceships(0);
        reloadData();
        cryptominesContract
          .getPastEvents('eventBurnSpaceship', { fromBlock: 'latest', toBlock: 'latest', address: [userAddress] })
          .then(async (results) => {
            SweetAlert.fire({
              title: 'Nice!',
              text: 'Your NFT was burned. 😊 ',
              icon: 'success',
            });
          });
      }
    });
  };

  const sellSpaceship = async (tokenId) => {
    window.gtag('event', 'sellSpaceship', { tokenId: tokenId, address: userAddress });

    SweetAlert.fire({
      title: 'For how much you will <b>SELL</b> this NFT? <br> You will receive 90% of the given price.',
      icon: 'question',
      input: 'text',
      confirmButtonText: 'Proceed',
      footer: '<center><span class="txt-danger">Please double check the amount of $ETERNAL.</span></center>',
    }).then(async (result) => {
      if (result.value) {
        const allNFTApproved = await spaceshipContract.methods
          .isApprovedForAll(userAddress, MARKETPLACE_CONTRACT)
          .call({ from: userAddress });
        if (allNFTApproved == false) {
          await spaceshipContract.methods.setApprovalForAll(MARKETPLACE_CONTRACT, true).send({ from: userAddress });
        }
        await marketplaceContract.methods
          .sellNFT(1, tokenId, web3.utils.toWei(result.value, 'ether'))
          .send({ from: userAddress });
        reloadData();
        SweetAlert.fire({
          title: 'Nice!',
          text: 'Your NFT was put in sale. 😊 ',
          icon: 'success',
        });
      }
    });
  };

  return (
    <Fragment>
      <Breadcrumb parent='Spaceships' title='Spaceships' />
      <Container fluid={true}>
        <Row>
          <Col sm='12'>
            <Card className='card-absolute'>
              <CardHeader className='bg-primary'>
                <h3>Spaceships</h3>
                {/* <button
                  className='toggle-information btn btn-success'
                  onClick={() => setToggleInformation(!toggleInformation)}
                >
                  ?
                </button> */}
              </CardHeader>
              <CardBody>
                <Information section='spaceships' display={true} />
                <Row>
                  <Col sm='4'>
                    <Card className='o-hidden '>
                      <CardBody>
                        <center>
                          <p className='f-w-500 font-roboto f-26'>
                            <b>MINT Spaceship</b>
                          </p>
                          <EternalBtn action={mintSpaceship}>Pay {parseFloat(parseFloat(mintCost).toFixed(3))} ETERNAL </EternalBtn>

                          {!canMint ? (
                            <p className='txt-danger'>
                              Your currently have the max allowed Spaceships. <br /> Can't go to expeditions with this
                              many Spaceships
                            </p>
                          ) : (
                            ''
                          )}
                        </center>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col sm='4'>
                    <Card className='o-hidden'>
                      <CardBody>
                        <center>
                          <p className='f-w-500 font-roboto f-26'>
                            <b>Current Spaceships</b>
                          </p>
                          <h4 className='f-w-500 mb-0 f-26'>
                            <span className='badge pill-badge-warning ml-3'>{spaceshipAmount}/10 Spaceships</span>
                          </h4>
                        </center>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col sm='4'>
                    <Card className='o-hidden'>
                      <CardBody>
                        <center>
                          <p className='f-w-500 font-roboto f-26'>
                            <b>Max Workers</b>
                          </p>
                          <h4 className='f-w-500 mb-0 f-26'>
                            <span className='badge pill-badge-secondary ml-3'>{maxWorkers} Workers</span>
                          </h4>
                        </center>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                <div>
                  {queueItems >= 1 ? (
                    <>
                      <hr />
                      <h4>Awaiting deployment</h4>
                      <p>Your engineers are inspecting the spaceship, it will be ready soon.</p>
                      <Row className='gridRow'>
                        {Array(queueItems)
                          .fill(0)
                          .map((_, index) => {
                            return (
                              <div key={index} className='col-xl-3 col-sm-6 xl-4 col-grid-box'>
                                <Card>
                                  <div className='product-box'>
                                    <div className='product-img'>
                                      {videoAnimation ? (
                                        <video
                                          className='img-fluid'
                                          muted
                                          loop={videoAnimation}
                                          autoPlay={videoAnimation}
                                          poster={`${ASSETS_CDN}/lootbox-placeholder.png`}
                                        >
                                          <source src={`${ASSETS_CDN}/lootbox.mp4`} type='video/mp4' />
                                          <img alt='spaceship' src={`${ASSETS_CDN}/lootbox-placeholder.png`} />
                                        </video>
                                      ) : (
                                        <img alt='spaceship' src={`${ASSETS_CDN}/lootbox.png`} />
                                      )}
                                    </div>
                                    <div className='product-details'>
                                      <div className=''>
                                        <center>
                                          <Button
                                            variant='primary'
                                            onClick={() => {
                                              revealNFT(cryptominesContract, userAddress, 1).then((response) => {
                                                setTimeout(() => {
                                                  reloadData();
                                                }, 3000);
                                                shouldUpdate(Math.random());
                                                SweetAlert.fire({
                                                  title: 'Nice!',
                                                  text: 'A new spaceship joined your fleet.',
                                                  icon: 'success',
                                                });
                                              });
                                            }}
                                          >
                                            Open Box{' '}
                                            <span role='img' aria-label='box'>
                                              📦
                                            </span>
                                          </Button>
                                        </center>
                                      </div>
                                    </div>
                                  </div>
                                </Card>
                              </div>
                            );
                          })}
                      </Row>
                    </>
                  ) : undefined}
                </div>

                <hr />
                <Row className='gridRow'>
                  {spaceshipList
                    ? spaceshipList.map((spaceship, i) => (
                        <div
                          className={`${
                            layoutColumns === 3 ? 'col-xl-3 col-sm-6 xl-4 col-grid-box' : 'col-xl-' + layoutColumns
                          }`}
                          key={spaceship.id}
                        >
                          <Card>
                            <div className='product-box'>
                              <span className='ribbon ribbon'>
                                <b>UID: </b> 0x{spaceship.uid}
                                <br />
                                <b>Name: </b> {spaceship_firstName[spaceship.firstName]}{' '}
                                {spaceship_lastName[spaceship.lastName]}
                                <br />
                                <b>Transfer Cooldown: </b>{' '}
                                {spaceship.canTransfer ? (
                                  'Available'
                                ) : (
                                  'Available'
                                )}
                              </span>

                              <div className='product-img'>
                                <span className='ribbon ribbon-clip-bottom-right ribbon-primary'>
                                  <b>Spaceship Rarity:</b>{' '}
                                  <Rating
                                    initialRating={spaceship.level}
                                    emptySymbol='fa fa-star-o'
                                    fullSymbol='fa fa-star'
                                    readonly={true}
                                  />{' '}
                                  <br />
                                </span>

                                {videoAnimation ? (
                                  <video
                                    className='img-fluid'
                                    muted
                                    loop={videoAnimation}
                                    autoPlay={videoAnimation}
                                    poster={`${ASSETS_CDN}/spaceships/rank${spaceship.level}/${spaceship.variant}.png`}
                                  >
                                    <source
                                      src={`${ASSETS_CDN}/spaceships/rank${spaceship.level}/${spaceship.variant}.mp4`}
                                      type='video/mp4'
                                    />
                                  </video>
                                ) : (
                                  <img className='img-fluid'
                                    alt='Spaceship NFT'
                                    src={`${ASSETS_CDN}/spaceships/rank${spaceship.level}/${spaceship.variant}.png`}
                                  />
                                )}

                                <div className='product-hover'>
                                  <ul>
                                    <li>
                                      <Button color='default' onClick={() => burnSpaceship(spaceship.id, i)}>
                                        <i className='icon-trash'></i>
                                      </Button>
                                    </li>
                                    <li>
                                      <Button
                                        color='default'
                                        onClick={() => giftAsset(spaceship.id, spaceshipContract, userAddress)}
                                      >
                                        <i className='icon-gift'></i>
                                      </Button>
                                    </li>

                                    <li>
                                      <Button color='default' onClick={() => sellSpaceship(spaceship.id)}>
                                        <i className='icon-shopping-cart'></i>
                                      </Button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className='product-details'>
                                <div className='product-price'>
                                  <center> {spaceship.level} WORKERS </center>
                                </div>
                              </div>
                            </div>
                          </Card>
                        </div>
                      ))
                    : ''}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Spaceships;
